var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.features),function(feature){return _c('div',{key:feature.id},[(feature)?_c('div',[_vm._v(_vm._s(feature))]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }